import { __awaiter } from "tslib";
import jsonPath from "jsonpath";
import { clone } from "ramda";
class JsonPathAdapter {
    constructor(wrappedAdapter) {
        this.wrappedAdapter = wrappedAdapter;
        this.rootDocument = null;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.wrappedAdapter.init();
        });
    }
    set(contentPath, content) {
        if (this.rootDocument === null) {
            this.rootDocument = {};
        }
        let currentDocument = clone(this.rootDocument);
        // updated content
        if (contentPath !== "" && contentPath !== "$") {
            jsonPath.value(currentDocument, contentPath, content);
        }
        else {
            currentDocument = clone(content);
        }
        return this.wrappedAdapter.set(contentPath, currentDocument);
    }
    get(contentPath) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentDocument = yield this.wrappedAdapter.get(contentPath);
            this.rootDocument = clone(currentDocument);
            /**
             * To avoid errors when the current document is null, which happens with new wallets
             */
            return currentDocument
                ? jsonPath.value(currentDocument, contentPath)
                : null;
        });
    }
    has(contentId) {
        return this.wrappedAdapter.has(contentId);
    }
}
export default JsonPathAdapter;
